import {
    QueueSheetManagementRows
} from '../../BookingManagement/components/QueueSheetManagement/interface/QueueSheetInterface';
import { SearchSuggestion } from '../../UiComponentsLibrary/CustomSearchInput';
import { UserInterface } from '../interfaces/user/UserInterfaces';

type SearchableData = UserInterface | QueueSheetManagementRows;

export const generateSearchSuggestions = <T extends SearchableData>(
    data: T[],
    searchableFields: Partial<Record<keyof T, string>>
): SearchSuggestion[] => {
    const suggestionMap = new Map<string, SearchSuggestion>();

    data.forEach((item) => {
        // Extract suggestions from each searchable field
        Object.entries(searchableFields).forEach(([field, displayName]) => {
            const value = item[field as keyof T];
            if (value) {
                const transformedValue = value.toString().trim().toLowerCase();

                if (transformedValue) {
                    const suggestionKey = `${field}-${transformedValue}`;

                    if (!suggestionMap.has(suggestionKey)) {
                        suggestionMap.set(suggestionKey, {
                            value: transformedValue,
                            field: displayName,
                            meta: `in ${displayName}`,
                        });
                    }
                }
            }
        });
    });

    return Array.from(suggestionMap.values()).sort((a, b) =>
        a.value.localeCompare(b.value)
    );
};
